// import { useContext } from "react";
// import { Navigate } from "react-router-dom";
// import AuthContext from "./AuthContext";

// const ProtectedRoute = ( props: any ) => {
//   const { user } = useContext(AuthContext);

//   const userProfile = localStorage.getItem("userProfile");

//   if (props.accessBy === "authenticated") {
//     if (userProfile) {
//       return props.children;
//     }
//   }

//   if (props.accessBy === "non-authenticated") {
//     if (userProfile) {
//       return <Navigate to="/home" replace/>
//     }
//     return props.children;
//   }
//   return <Navigate to="/" replace/>;
// };
// export default ProtectedRoute;

import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useGetBrokerByIdQuery } from '../services/features/brokerApi/brokerApi';
import { RootState } from '../store';

type ProtectedRouteProps = {
	accessBy: 'authenticated' | 'non-authenticated';
	children: React.ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ accessBy, children }) => {

	const brokerId = useSelector((state: RootState) => state.authSlice.id);
	const { data: broker, isLoading, isUninitialized } = useGetBrokerByIdQuery(brokerId ?? skipToken, { skip: !brokerId });

    if ((isLoading || isUninitialized) && brokerId) {
        return <LoadingPage />;
    }

	// Handling non-authenticated routes
	if (accessBy === 'non-authenticated') {
		if (brokerId) {
			return <Navigate to='/home' replace />;
		}
		return <>{children}</>;
	}

	// Handling authenticated routes
	if (accessBy === 'authenticated' && brokerId) {
		return <>{children}</>;
	}

	// Default redirection to the root path if no conditions are met.
	return <Navigate to='/' replace />;
};

export default ProtectedRoute;
